import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { ChevronRight, ExternalLink } from "lucide-react";

export default function NoticeListPage({ category, title }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/notices", { params: { category } }).then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, [category]);

  const link = (n) => {
    if (n.link_type === "file" && n.file_id) return fileUrl(n.file_id);
    if (n.link_type === "external" && n.external_link) return n.external_link;
    return null;
  };

  return (
    <div className="inner-page" data-testid={`notice-list-${category}`}>
      <h1 className="page-title">{title}</h1>
      <ul className="notice-list">
        {loading && <li className="empty">Loading...</li>}
        {!loading && items.length === 0 && <li className="empty">No notices available.</li>}
        {items.map((n, i) => {
          const href = link(n);
          return (
            <li key={n.id} data-testid={`notice-item-${i}`}>
              <ChevronRight size={14} className="li-chevron" />
              {href ? (
                <a href={href} target="_blank" rel="noreferrer">
                  {n.title} <ExternalLink size={12} />
                </a>
              ) : (
                <span>{n.title}</span>
              )}
              {n.is_new && <span className="new-tag">New</span>}
              <span className="notice-date">{n.date}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
